import React from "react";

/**
 * the entry point
 */
const PRDBannerProductBelowPrice = () => {


    const bannerBelowPrice = document.getElementById('banner-product-below-price');
    const bannerBelowPriceContent = bannerBelowPrice?.innerHTML;
    return (

            <>
                {
                    bannerBelowPriceContent && <div className={`banner-product-below-price-react is-top-image-true`}>
                            <div dangerouslySetInnerHTML={{ __html: bannerBelowPriceContent }} />
                        </div>

                }
            </>
    )
};

export default PRDBannerProductBelowPrice;